import { inject } from '@angular/core';
import { RedirectFunction, Router, UrlTree } from '@angular/router';

import { ORG_ID_PARAM } from '@app/shared/app-router.service';

export interface RedirectToOptions {
  url: string[];
  map?: Record<string, string>;
  queryParams?: Record<string, string>;
}

export const redirectTo = ({
  url,
  map = {},
  queryParams = {},
}: RedirectToOptions): RedirectFunction => {
  return ({ params: originalParams, queryParams: originalQueryParams, fragment }): UrlTree => {
    const router = inject(Router);
    const urlSegments = [];

    for (const segment of url) {
      if (segment.startsWith(':')) {
        const param = segment.slice(1);
        urlSegments.push(originalParams[param]);
      } else {
        urlSegments.push(segment);
      }
    }

    for (const source of Object.keys(map)) {
      const key = map[source] as string;
      queryParams[key] = originalQueryParams[source] ?? originalParams[source] ?? source;
    }

    for (const [key, value] of Object.entries(originalQueryParams)) {
      if (key === 'o') {
        queryParams[ORG_ID_PARAM] = value;
      } else {
        queryParams[key] = value;
      }
    }

    return router.createUrlTree(urlSegments, {
      queryParams,
      fragment: fragment ?? undefined,
      queryParamsHandling: '',
    });
  };
};
